import { useEffect } from 'react';

export const usePreloadImages = (urls: string[]) => {
  useEffect(() => {
    urls.forEach((url) => {
      document.createElement('img').src = url;
    });
  }, [urls]);
};
